import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../static/css/Nav.css";

function Nav() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <div className="Nav-bar">
        <div className="nav-content">
          <Link to="/" style={{ textDecoration: "none" }}>
            <h2 style={{
              color: "#d4af37",
              margin: 0,
              fontSize: "1.5rem",
              fontWeight: "700",
              letterSpacing: "0.5px"
            }}>
              SPP IPE
            </h2>
          </Link>
          <span className="menu-icon" onClick={toggleSidebar}>
            &#9776;
          </span>
          <ul>
            <Link to="/">
              <li>Home</li>
            </Link>
            <Link to="/about">
              <li>About Us</li>
            </Link>
            <Link to="/team">
              <li>Our Team</li>
            </Link>
            <Link to="/services">
              <li>Services</li>
            </Link>
            <Link to="/cases">
              <li>Insolvency Cases</li>
            </Link>
            <Link to="/publications">
              <li>Our Publications</li>
            </Link>
            <Link to="/news">
              <li>What's New</li>
            </Link>
            <Link to="/knowledge">
              <li>Knowledge Bank</li>
            </Link>
            <Link to="/contact">
              <li>Contact Us</li>
            </Link>
            <div className="Log-In-Desktop">
              <Link to="/login">
                <button className="nav-login-btn">Login</button>
              </Link>
            </div>
          </ul>
        </div>
      </div>
      <div className="sidebar" style={{ width: isOpen ? "250px" : "0" }}>
        <span className="closebtn" onClick={toggleSidebar}>
          &times;
        </span>
        <div className="sidebar-header">
          <Link to="/login" onClick={toggleSidebar}>
            <button className="sidebar-login-btn">Log In</button>
          </Link>
        </div>
        <ul>
          <Link to="/" onClick={toggleSidebar}>
            <li>Home</li>
          </Link>
          <Link to="/about" onClick={toggleSidebar}>
            <li>About Us</li>
          </Link>
          <Link to="/team" onClick={toggleSidebar}>
            <li>Our Team</li>
          </Link>
          <Link to="/services" onClick={toggleSidebar}>
            <li>Services</li>
          </Link>
          <Link to="/cases" onClick={toggleSidebar}>
            <li>Insolvency Cases</li>
          </Link>
          <Link to="/publications" onClick={toggleSidebar}>
            <li>Our Publications</li>
          </Link>
          <Link to="/news" onClick={toggleSidebar}>
            <li>What's New</li>
          </Link>
          <Link to="/knowledge" onClick={toggleSidebar}>
            <li>Knowledge Bank</li>
          </Link>
          <Link to="/contact" onClick={toggleSidebar}>
            <li>Contact Us</li>
          </Link>
        </ul>
      </div>
    </>
  );
}

export default Nav;
